/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

/**
 * Copyright (c) 2013 MOCA Systems, Inc.  All rights reserved.
 *
 * src/main/resources/com/mocasystems/mb4/ui/ng/ticketspace-directives.js
 *
 * Angular directives for ticketspace-app.js.
 */
'use strict';

import * as angular from 'angular';
// import * as Papa from "js/vendor/papaparse"
// const Papa = require("js/vendor/papaparse");

import Papa from '@appLegacy/vendor/papaparse.min';
import { LoggerServiceFactory } from 'src/app/common/logging/LoggerServiceFactory';

angular.module('ticketspaceApp').directive('ticketImport', [
	'$parse',
	function ($parse) {
		const logger = LoggerServiceFactory.create('ticketImport');
		//first cut, we'll only support names
		//in this case, that means blindly splitting on newlines
		function parseInput(input, cb) {
			if (!input) {
				Logging.warning('Nothing to add...');
				return;
			}
			var config = {
				header: true,
				dynamicTyping: true,
				skipEmptyLines: true,
				complete: function (results) {
					if (cb) {
						cb(results);
					}
				},
			};
			Papa.parse(input, config);
		}

		function processResults(results) {
			if (!results || results.errors.length !== 0) {
				logger.log('errors occured', results);
			}

			logger.log('results', results);
		}

		return {
			restrict: 'EA',
			scope: true,
			link: function (scope: any, element, attrs) {
				var cb = $parse(attrs.ticketImport);
				logger.log('attrs', attrs, attrs.map);
				if (attrs.map) {
					var processFunction = $parse(attrs.map);
				}

				scope.add = function (successCb) {
					var contents = element.find('textarea').val();

					if (!contents) {
						var file = (element.find('input')[0] as any).files[0];
						parseInput(file, done);
					} else {
						parseInput(contents, done);
					}

					function done(results) {
						if (!results || results.errors.length !== 0) {
							logger.log('errors occured', results);
							return;
						}

						if (processFunction) {
							var out = processFunction(scope, { list: results.data });
							if (!out) {
								Logging.error('could not process csv');
								return;
							}
							successCb();
							cb(scope, { list: out });
						} else {
							logger.log('no process');
							successCb();
							cb(scope, { list: results.data });
						}
					}

					// successCb();
					// cb(scope, {list:output});
				};
			},
			template: require('html-loader?root=src/!tpl/bulk.html'),
		};
	},
]);
